import { useStore } from "vuex";

/**
 * Add or remove the "dark" class based on if the media query matches
 * @param {boolean} shouldAdd whether to add the ```'dark'``` class or not
 * @returns {'dark' | 'lignt'} the curent theme
 */
const toggleDarkTheme = (shouldAdd: boolean) => {
  document.body.classList.toggle('dark', shouldAdd);

  const store = useStore()
  store.commit('setDarkTheme', shouldAdd);

  return shouldAdd ? 'dark' : 'loght';
}

export default toggleDarkTheme;

// completed
